import { useState } from 'react';

export default function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [cookiesOpen, setCookiesOpen] = useState(false);

  return (
    <>
      <footer className="relative py-12 bg-[#fbf9f4]">
        
        {/* Decorative subtle pattern */}
        <div className="absolute inset-0 opacity-[0.02] pointer-events-none" style={{ backgroundImage: 'radial-gradient(circle, #00A8B5 1px, transparent 1px)', backgroundSize: '24px 24px' }}></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <img
                src="https://storage.readdy-site.link/project_files/d8db5950-dd7c-40d9-b2de-72ddcdf21388/51e73aae-ba15-478d-bf7b-7a4446e0d24c_fond-transparent.png?v=f8b7e998649839c3a23fd4205efaa02e"
                alt="PLUG and BAR LM Logo"
                className="h-24 w-auto max-w-[360px] mb-6"
              />
              <p className="text-gray-600 text-sm leading-relaxed">
                La solution bar clé en main.
              </p>
              
              {/* Social icons */}
              <div className="flex items-center gap-3 mt-4">
                <a href="https://www.instagram.com/plugandbar/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-[#00A8B5]/10 hover:bg-[#00A8B5]/20 transition-colors duration-300 cursor-pointer group">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-instagram-line text-[#00A8B5] group-hover:scale-110 transition-transform duration-200"></i>
                  </div>
                </a>
                <a href="https://www.facebook.com/profile.php?fb_profile_edit_entry_point=%7B%22click_point%22%3A%22edit_profile_button%22%2C%22feature%22%3A%22profile_header%22%7D&id=61589649323917&sk=about&locale=fr_FR" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-[#00A8B5]/10 hover:bg-[#00A8B5]/20 transition-colors duration-300 cursor-pointer group">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-facebook-line text-[#00A8B5] group-hover:scale-110 transition-transform duration-200"></i>
                  </div>
                </a>
                <a href="https://www.linkedin.com/company/plugandbar/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-[#00A8B5]/10 hover:bg-[#00A8B5]/20 transition-colors duration-300 cursor-pointer group">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-linkedin-line text-[#00A8B5] group-hover:scale-110 transition-transform duration-200"></i>
                  </div>
                </a>
              </div>
            </div>
            <div>
              <h4 className="text-gray-800 font-semibold mb-4">Navigation</h4>
              <ul className="space-y-2 text-gray-600 text-sm">
                <li><a href="#" className="hover:text-[#00A8B5] transition-colors duration-200 cursor-pointer">Accueil</a></li>
                <li><a href="#remorque" className="hover:text-[#00A8B5] transition-colors duration-200 cursor-pointer">La Remorque</a></li>
                <li><a href="#pourquoi" className="hover:text-[#00A8B5] transition-colors duration-200 cursor-pointer">Pourquoi nous choisir</a></li>
                <li><a href="#tarifs" className="hover:text-[#00A8B5] transition-colors duration-200 cursor-pointer">Tarifs</a></li>
                <li><a href="#personnalisation" className="hover:text-[#00A8B5] transition-colors duration-200 cursor-pointer">Personnalisation</a></li>
                <li><a href="#devis" className="hover:text-[#00A8B5] transition-colors duration-200 cursor-pointer">Devis</a></li>
                <li><a href="#services" className="hover:text-[#00A8B5] transition-colors duration-200 cursor-pointer">Nos Clients</a></li>
                <li><a href="#apropos" className="hover:text-[#00A8B5] transition-colors duration-200 cursor-pointer">À Propos</a></li>
                <li><a href="#contact" className="hover:text-[#00A8B5] transition-colors duration-200 cursor-pointer">Contact</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-gray-800 font-semibold mb-4">Nos engagements</h4>
              <ul className="space-y-2 text-gray-600 text-sm">
                <li className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-[#00A8B5] text-xs"></i>
                  </div>
                  Installation rapide
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-[#00A8B5] text-xs"></i>
                  </div>
                  Service professionnel
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-[#00A8B5] text-xs"></i>
                  </div>
                  Disponible dans toute la Suisse
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-200/80 mt-8 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center text-gray-600 text-sm">
              <div className="flex flex-col items-center md:items-start">
                <p>© 2026 Remorque Bar. Tous droits réservés.</p>
                <a
                  href="https://manova-digital.ch"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 text-xs mt-1 hover:text-[#00A8B5] transition-colors duration-300 cursor-pointer"
                >
                  Création signée Manova Digital
                </a>
              </div>
              <div className="flex space-x-6 mt-4 md:mt-0">
                <button
                  onClick={() => setPrivacyOpen(true)}
                  className="hover:text-[#00A8B5] transition-colors duration-200 cursor-pointer relative group"
                >
                  Confidentialité
                  <span className="absolute -bottom-0.5 left-0 w-0 h-px bg-[#00A8B5] group-hover:w-full transition-all duration-300"></span>
                </button>
                <button
                  onClick={() => setCookiesOpen(true)}
                  className="hover:text-[#00A8B5] transition-colors duration-200 cursor-pointer relative group"
                >
                  Cookies
                  <span className="absolute -bottom-0.5 left-0 w-0 h-px bg-[#00A8B5] group-hover:w-full transition-all duration-300"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Modal */}
      {privacyOpen && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-50">
          <div className="bg-gray-900 rounded-lg border border-[#00A8B5]/30 max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-2xl font-semibold text-[#00A8B5]">Politique de Confidentialité</h3>
                <button
                  onClick={() => setPrivacyOpen(false)}
                  className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-white cursor-pointer"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>
              <div className="space-y-6 text-gray-300 text-sm leading-relaxed">
                <div>
                  <h4 className="text-lg font-semibold text-[#00A8B5] mb-3">Collecte des données</h4>
                  <p>Remorque Bar collecte uniquement les données nécessaires au traitement de vos demandes de location et à la fourniture de nos services. Les informations collectées comprennent : nom, prénom, adresse email, numéro de téléphone, détails de l&apos;événement.</p>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-[#00A8B5] mb-3">Utilisation des données</h4>
                  <p className="mb-2">Vos données personnelles sont utilisées exclusivement pour :</p>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>Traiter vos demandes de devis et réservations</li>
                    <li>Communiquer avec vous concernant votre événement</li>
                    <li>Améliorer nos services</li>
                  </ul>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-[#00A8B5] mb-3">Protection des données</h4>
                  <p className="mb-2">Conformément à la Loi fédérale sur la protection des données (LPD) suisse, nous nous engageons à :</p>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>Protéger vos données contre tout accès non autorisé</li>
                    <li>Ne pas transmettre vos données à des tiers sans votre consentement</li>
                    <li>Vous permettre d&apos;exercer vos droits d&apos;accès, de rectification et de suppression</li>
                  </ul>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-[#00A8B5] mb-3">Contact</h4>
                  <p>Pour toute question concernant vos données personnelles, contactez-nous à : contact@remorquebar.ch</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Cookies Modal */}
      {cookiesOpen && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-50">
          <div className="bg-gray-900 rounded-lg border border-[#00A8B5]/30 max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-2xl font-semibold text-[#00A8B5]">Politique des Cookies</h3>
                <button
                  onClick={() => setCookiesOpen(false)}
                  className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-white cursor-pointer"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>
              <div className="space-y-6 text-gray-300 text-sm leading-relaxed">
                <div>
                  <h4 className="text-lg font-semibold text-[#00A8B5] mb-3">Qu&apos;est-ce qu&apos;un cookie ?</h4>
                  <p>Un cookie est un petit fichier texte stocké sur votre appareil lors de votre visite sur notre site web. Les cookies nous aident à améliorer votre expérience de navigation.</p>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-[#00A8B5] mb-3">Types de cookies utilisés</h4>
                  <div className="space-y-4">
                    <div>
                      <h5 className="font-semibold text-white">Cookies essentiels</h5>
                      <p className="text-sm">Nécessaires au fonctionnement du site. Ils ne peuvent pas être désactivés.</p>
                    </div>
                    <div>
                      <h5 className="font-semibold text-white">Cookies d&apos;analyse</h5>
                      <p className="text-sm">Nous aident à comprendre comment vous utilisez notre site pour l&apos;améliorer.</p>
                    </div>
                    <div>
                      <h5 className="font-semibold text-white">Cookies marketing</h5>
                      <p className="text-sm">Utilisés pour personnaliser les publicités et mesurer l&apos;efficacité de nos campagnes.</p>
                    </div>
                  </div>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-[#00A8B5] mb-3">Conformité légale</h4>
                  <p>Notre utilisation des cookies est conforme à la Loi fédérale sur la protection des données (LPD) suisse et aux directives européennes en matière de cookies.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
